import {isInProdEnvFn, isInShowEnvFn} from '@/mm/utils.js'
import { ref } from 'vue'

export const defaultTitle = '瑞诺主题设计平台'

export const baseUrl = 'https://admin-api.uniquecncmach.com'

var isInProdEnv = isInProdEnvFn()
var isInShowEnv = isInShowEnvFn()


export const imgUrl = (()=>{
  if (isInShowEnv) {
    return 'https://manage-admin.show.chukouplus.com'
  }else{
    return !isInProdEnv
      ? 'https://admin.uniquecncmach.com'
      : 'https://www.chukouplus.com'
  }

})()

export const safeList = [
  { label: '1680px', value: 1680 },
  { label: '1600px', value: 1600 },
  { label: '1400px', value: 1400 },
  { label: '1200px', value: 1200 }
]
export const COMMON_COMPONENT = 'common'
export const emptyDataStructure = (list = [])=> {
  return {
    name: '页面',
    startNode: true,
    componentName: 'content',
    _type: 'bodyBase',
    list: [
      {
        name: '空白模块',
        tips: '可拖入控件到此位置',
        componentName: 'module',
        _type: 'module1',
        startNode: true,
        id: 'id_1_0',
        isCustomModule: true,
        list: [
          {
            name: '一行一列',
            _type: 'widgets_rowCol1',
            componentName: 'rowCol2',
            changeWidth:false,
            id: 'id_1_0_0',
            diffWidth: ['p1-0', 's1-0'],
            list: [
              {
                name: '列',
                componentName: 'col',
                _width: '100',
                flag: 'content-col',
                list
              }
            ]
          }
        ]
      }
    ]
  }
}

export const TEXT_REMARK_MAP = new Map([
  [3, '内页模块标题'],
  [4, '详情页标题'],
  [5, '列表标题']
])

export const TEXT_REMARK_OBJECT = Object.fromEntries(TEXT_REMARK_MAP)
